export default __webpack_public_path__ + "static/media/wherebyIcon.7e347aa5.png";